import React, { createContext, useState } from 'react'

export const ProductContext = createContext({})

export const ProductProvider = ({ children }) => {
  const [types, setTypes] = useState([])
  const [categories, setCategories] = useState([])
  const [managementStyles, setManagementStyles] = useState([])
  const [goals, setSelectedGoals] = useState([])
  return (
    <ProductContext.Provider
      value={{
        types,
        setTypes,
        categories,
        setCategories,
        managementStyles,
        setManagementStyles,
        goals,
        setSelectedGoals,
      }}
    >
      {children}
    </ProductContext.Provider>
  )
}
